import { FC } from "react";
import css from './index.module.css';

interface Tabs {
  active?: number
  setActive?: any
}

const Tabs:FC<Tabs> = ({ active, setActive }) => {
  return (
    <div className={css.sections}>
      <div className={`${css.section} ${active === 0 ? css.active : ''}`} onClick={() => setActive(0)}>Данные пользователя</div>
      <div className={`${css.section} ${active === 1 ? css.active : ''}`} onClick={() => setActive(1)}>Коммуникации</div>
      <div className={`${css.section} ${active === 2 ? css.active : ''}`} onClick={() => setActive(2)}>Организации</div>
    </div>
  );
};

export default Tabs;